export default __webpack_public_path__ + "static/vanderbilt-1-fa671ccc1d853ecf0e2c8c77e9f507ac.png";